import { BlockDayService, datesData } from '@pages/admin/calendarios/calendarios-bloqueo/block-day.service';
import { DatesDataInd } from '@pages/admin/calendarios/calendarios-bloqueo/block-day.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateStruct, NgbDatepickerConfig, NgbDatepicker  } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Observable } from 'rxjs';
import { ObservatoryService, StorageService } from '@services/services.module';
import { CalendarSelectDateService } from '../popup-calendar/calendar-select-date.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '@services/notifications/notifications.service';

@Component({
  selector: 'app-range-calendar',
  templateUrl: './range-calendar.component.html',
  styleUrls: ['./range-calendar.component.scss'],
  providers: [NgbDatepickerConfig]
})
export class RangeCalendarComponent implements OnInit, OnDestroy, AfterViewInit {

  // markDisable distingue un calendario de otro, si es TRUE, quiero un calendario con dias bloqueados y rango para poder bloquear fechas
  // de lo contrario simplemente cargara un calendario con rango
  @Input() markDisable = false;
  @Input() resetearFocus: Observable<void>;
  @Input() setToDate: Observable<any>;
  @Input() setFromDate: Observable<any>;
  @Input() resetEndDate: Observable<void>;
  @Output() refreshCalendar: EventEmitter<any> = new EventEmitter();
  @Output() sendFromDate: EventEmitter<NgbDate> = new EventEmitter<NgbDate>();
  @Output() sendToDate: EventEmitter<NgbDate> = new EventEmitter<NgbDate>();
  @ViewChild('dp') datepicker: NgbDatepicker;


  private toDate: NgbDate;
  private list: Array<any> = [];
  private listBlockExternal: Array<any> = [];
  private listBlockEmploye: Array<any> = [];
  private fechaBloqHasta: any;
  private subscriptions: Array<Subscription> = [];
  public hoveredDate: NgbDate;
  public model: NgbDateStruct;
  public fromDate: NgbDate;
  public employeeId: number;
  public userData: any;
  public dateYear: any;
  public dateMonth: any;
  public dateMonthStr;
  public dateYear2: any;
  public dateMonth2: any;
  public dateMonthStr2;
  public anio: string;
  public mes: string;
  public dia: string;
  public dateInitBloq: any = undefined;
  public today = new Date();

  constructor(
    public calendar: NgbCalendar,
    private blockDayService: BlockDayService,
    private _observatoryService: ObservatoryService,
    public config: NgbDatepickerConfig,
    private storage: StorageService,
    public CalendarSelectDate: CalendarSelectDateService,
    private translate: TranslateService,
    private notification: NotificationsService,
    private observatory: ObservatoryService) {
    this.markDisabled = this.markDisabled.bind(this);
  }

  ngOnInit(): void {
    // traemos los datos del usuario
    if (this.storage.get('userDataStorage')) {
      this.userData = this.storage.get('userDataStorage');
    } else {
      this.userData = this._observatoryService.getData('userDataStorage');
    }
    this.model = this.calendar.getToday();
    this.subscriptions.push(this.resetearFocus.subscribe(() => this.resetFocusAndSelection()));
    if (this.setToDate) {
      this.subscriptions.push(this.setToDate.subscribe(ev => this.setToDateFunction(ev)));
    }
    if (this.setToDate) {
      this.subscriptions.push(this.setFromDate.subscribe(ev => this.setFromDateFunction(ev)));
    }
    if (this.resetEndDate) {
      this.subscriptions.push(this.resetEndDate.subscribe(() => this.toDate = undefined));
    }

    // primero generamos los parametros necesarios para llamar al servicio
    // y cargar del calendario los días bloqueados.
    this.dateMonth = this.calendar.getToday().month === 1
      ? 12 : this.calendar.getToday().month - 1;
    this.dateYear = this.calendar.getToday().month !== 1
      ? '' + this.calendar.getToday().year
      : '' + (this.calendar.getToday().year - 1);
    const str = '' + this.dateMonth;
    const pad = '00';
    this.dateMonthStr = pad.substring(0, pad.length - str.length) + str;

    // Datos para traer el mes actual
    this.dateMonth2 = this.calendar.getToday().month;
    this.dateYear2 = '' + this.calendar.getToday().year;
    const str2 = '' + this.dateMonth2;
    const pad2 = '00';
    this.dateMonthStr2 = pad2.substring(0, pad2.length - str2.length) + str2;

    // calendario para bloqueo general
    if (this.markDisable) {
      this.buildCalendar();
      this.refreshCalendar.emit();
      return;
    } else {
      this.dateInitBloq = {
        year: Number(this.calendar.getToday().year),
        month: Number(this.calendar.getToday().month),
        day: Number(this.calendar.getToday().day)
      };
    }
  }

  ngAfterViewInit(): void {
    // calendario para bloqueo general
    if (this.markDisable) {
      this.buildCalendar();
      this.refreshCalendar.emit();
      return;
    } else {
      this.dateInitBloq = {
        year: Number(this.calendar.getToday().year),
        month: Number(this.calendar.getToday().month),
        day: Number(this.calendar.getToday().day)
      };
    }
  }

  setToDateFunction(data) {
    this.navigateToDate(data);

    if (data) {
      this.toDate = data;
    }
  }

  setFromDateFunction(data) {
    this.navigateToDate(data);
    if (data) {
      this.fromDate = data;
    }
  }

  /**
   * Function to mark date as disabled
   *  1. Bloquear las fechas menores que la especificada en el bloqueo
   *  2. Bloquear el año superior al de bloqueo y superior al actual
   */
  markDisabled(date: NgbDate) {
    return (new Date(date.month + '/' + date.day + '/' + date.year) <= new Date(this.dateInitBloq.month + '/' + this.dateInitBloq.day + '/' + this.dateInitBloq.year)) ||
    date.year > this.today.getFullYear();
  }

  getNextMonth(employeId?: number) {
    this.blockDayService
      .getCalendarBloq(
        this.dateYear2,
        this.dateMonthStr2,
        // si existe el empleado id, usamos este, si no enviamos un 0
        employeId ? employeId : 0
      )
      .subscribe(val => {
        // *** HASTA QUE LOS DATOS NO ESTÉN CARGADOS, NO CONSTRUIR EL CALENDARIO
        const lastDayCurrentMonth = new Date(this.calendar.getToday().year, this.calendar.getToday().month, 0);

        const locked = val.filter(x => x.locked === 'T');
        const externalLocked = val.filter(x => x.externalLocked === 'T');
        const employeeLocked = val.filter(x => x.employeeLocked === 'T');

        this.list = this.list.concat(locked);
        this.listBlockExternal = this.listBlockExternal.concat(externalLocked);
        this.listBlockEmploye = this.listBlockEmploye.concat(employeeLocked);

        const externallength = this.listBlockExternal.length;
        const Employelength = this.listBlockEmploye.length;

        // removeos de la lista de exernos de empleado, los bloqueos generales
        if (externallength) {
          for (let i = externallength - 1; i >= 0; i--) {
            if (this.listBlockExternal[i].locked === 'T') {
              this.listBlockExternal.splice(i, 1);
            }
          }
        }

        // removemos de la lista de bloqueos de empleado, los bloqueos exernos
        if (Employelength) {
          for (let i = Employelength - 1; i >= 0; i--) {
            // removeos de la lista de bloqueos de empleado, los bloqueos generales y los bloqueos externos
            if (this.listBlockEmploye[i].locked === 'T' || this.listBlockEmploye[i].externalLocked === 'T') {
              this.listBlockEmploye.splice(i, 1);
            }
          }
        }
        // una vez cargado del calendario los días bloqueados "x.locked === 'T'"
        // cargamos en fechaBloqHasta el último dia del calendario bloqueado.
        this.fechaBloqHasta = this.list[this.list.length - 1];
        this.storage.set('bloqDays', this.list[this.list.length - 1]);

        // cálculo para que el calendario no se confunda de año a la hora de mostrar
        // los meses del calendario. Primer mes a mostrar, 5 meses antes del mes en curso y se
        // establece en this.config.minDate
        // fecha máxima mes en curso
        const configMinDate = new Date();
        configMinDate.setMonth(configMinDate.getMonth() - 5);

        this.config.minDate = { year: configMinDate.getFullYear(), month: configMinDate.getMonth() + 1, day: 1 };
        this.config.maxDate = { year: Number(this.calendar.getToday().year), month: Number(this.calendar.getToday().month), day: lastDayCurrentMonth.getDate() };
        // primer mes en mostrar en la vista calendario ( ejemplo, 1 febrero, 2 marzo, 3 abril) de esta manera aparece marzo en el medio.
        this.config.startDate = {
          year: this.calendar.getToday().month === 1 ? this.calendar.getToday().year - 1 : this.calendar.getToday().year,
          month: this.calendar.getToday().month === 1 ? 12 : this.calendar.getToday().month - 1
        };
        this.config.outsideDays = 'hidden';
        // recojo dia mes y año para luego deshabilitar los días en el calendario, siempre menor o igual del ultimo dia bloqueado recogido
        // en el sevicio.
        if (this.fechaBloqHasta) {
          this.anio = this.fechaBloqHasta.date.substring(0, 4);
          this.mes = this.fechaBloqHasta.date.substring(4, 6);
          this.dia = this.fechaBloqHasta.date.substring(6, 8);
        }
        // objeto que utiliza el calendario para establecer los días bloqueados.
        this.dateInitBloq = {
          year: Number(this.anio || 0),
          month: Number(this.mes || 0),
          day: Number(this.dia || 0)
        };
        // this.observatory.setData('loader', true);
      });
  }

  buildCalendar(employeId?: number) {
    this.dateInitBloq = undefined;
    this.resetFocusAndSelection();
    this.subscriptions.push(
      this.blockDayService
        .getCalendarBloq(
          this.dateYear,
          this.dateMonthStr,
          // si existe el empleado id, usamos este, si no enviamos un 0
          employeId ? employeId : 0
        )
        .subscribe(val => {
          if (val && !(val.response && val.response.includes('ERR'))) {
            this.list = val.filter(x => x.locked === 'T');
            this.listBlockExternal = val.filter(x => x.externalLocked === 'T');
            this.listBlockEmploye = val.filter(x => x.employeeLocked === 'T');
            const externallength = this.listBlockExternal.length;
            const Employelength = this.listBlockEmploye.length;

            // removeos de la lista de exernos de empleado, los bloqueos generales
            if (externallength) {
              for (let i = externallength - 1; i >= 0; i--) {
                if (this.listBlockExternal[i].locked === 'T') {
                  this.listBlockExternal.splice(i, 1);
                }
              }
            }

            // removemos de la lista de bloqueos de empleado, los bloqueos exernos
            if (Employelength) {
              for (let i = Employelength - 1; i >= 0; i--) {
                // removeos de la lista de bloqueos de empleado, los bloqueos generales y los bloqueos externos
                if (this.listBlockEmploye[i].locked === 'T' || this.listBlockEmploye[i].externalLocked === 'T') {
                  this.listBlockEmploye.splice(i, 1);
                }
              }
            }
            if (employeId) {
              this.getNextMonth(employeId);
            } else {
              this.getNextMonth();
            }
          }
        })
    );

  }

  formatDates() {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      let endMes = '';
      let endDay = '';
      let initMes = '';
      let initDay = '';

      if (this.toDate.month < 10) {
        endMes = '0' + this.toDate.month;
      } else {
        endMes = '' + this.toDate.month;
      }
      if (this.toDate.day < 10) {
        endDay = '0' + this.toDate.day;
      } else {
        endDay = '' + this.toDate.day;
      }
      if (this.fromDate.day < 10) {
        initDay = '0' + this.fromDate.day;
      } else {
        initDay = '' + this.fromDate.day;
      }
      if (this.fromDate.month < 10) {
        initMes = '0' + this.fromDate.month;
      } else {
        initMes = '' + this.fromDate.month;
      }

      const dateEnd = '' + this.toDate.year + endMes + endDay;
      const dateInit = '' + this.fromDate.year + initMes + initDay;

      let dates = {};

      dates = {
        'dateEnd': dateEnd,
        'dateInit': dateInit
      };

      resolve(dates);
    });
  }

  blockDays() {
    // this._observatoryService.setData('loader', true);
    if (!this.toDate) {
      this.toDate = this.fromDate;
    }
    if (this.notAllowSelect()) {
      // errorMessage
      // Enviar al servicio de bloquear días, la fecha final y la fecha inicial del rango seleccionado en el calendario.
      this.formatDates().then(
        (val: datesData) => {
          this.subscriptions.push(
            this.blockDayService.bloqDates(val).subscribe(data => {
              if (data.response === 'OK') {
                if (this.toDate.month === this.calendar.getToday().month) {
                  this.storage.set('subtractMonth', false);
                } else {
                  this.storage.set('subtractMonth', true);
                }
                this.notification.setSuccess(this.translate.instant('BLOQ.OKBLOQ'));
                // actualizar página
                this.buildCalendar();
                this.refreshCalendar.emit();
              } else {
                this.notification.setWarning(this.translate.instant('BLOQ.ERRBLOQ'));
                // this._observatoryService.setData('loader', false);
              }
            })
          );
        },
        (err) => {
          console.error(err);
          // this._observatoryService.setData('loader', false);
        }
      );
    } else {
      // this._observatoryService.setData('loader', false);
    }
  }

  blockExternal() {
    if (!this.toDate) {
      this.toDate = this.fromDate;
    }
    if (this.notAllowSelect()) {

      this.formatDates().then(
        (val: datesData) => {
          this.subscriptions.push(
            this.blockDayService.bloqDatesExt(val).subscribe(data => {
              if (data.response === 'OK') {
                if (this.toDate.month === this.calendar.getToday().month) {
                  this.storage.set('subtractMonth', false);
                } else {
                  this.storage.set('subtractMonth', true);
                }
                this.notification.setSuccess(this.translate.instant('BLOQ.OKBLOQ'));
                // actualizar página
                this.buildCalendar();
                this.refreshCalendar.emit();
              } else {
                this.notification.setWarning(this.translate.instant('BLOQ.ERRBLOQ'));
                // this._observatoryService.setData('loader', false);
              }
            })
          );
        },
        (err) => {
          console.error(err);
          // this._observatoryService.setData('loader', false);
        }
      );
    } else {
      // this._observatoryService.setData('loader', false);
    }
  }

  getDates(startDate, stopDate) {
    const startDateF = new Date(startDate.year, startDate.month - 1, startDate.day);
    const stopDateF = new Date(stopDate.year, stopDate.month - 1, stopDate.day);

    const dateArray = new Array();
    const currentDate = startDateF;
    while (currentDate <= stopDateF) {
      dateArray.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    const days = [];
    dateArray.forEach(element => {
      const data = '' +
        element.getFullYear() +
        this.stringFormat(element.getMonth() + 1) +
        this.stringFormat(element.getDate());

      days.push(data);
    });

    return days;
  }

  stringFormat(data) {
    if (data <= 9) {
      return '0' + data;
    } else {
      return data;
    }
  }

  blockIndividual() {
    if (!this.toDate) {
      this.toDate = this.fromDate;
    }
    if (this.notAllowSelect()) {
      const datesToLock = this.getDates(this.fromDate, this.toDate);
      const datesDataInd: DatesDataInd = {
        'datesToLock': datesToLock,
        employeeId: this.employeeId
      };
      this.subscriptions.push(
        this.blockDayService.bloqDatesInd(datesDataInd).subscribe(data => {
          if (data.response === 'OK') {
            if (this.toDate.month === this.calendar.getToday().month) {
              this.storage.set('subtractMonth', false);
            } else {
              this.storage.set('subtractMonth', true);
            }
            this.notification.setSuccess(this.translate.instant('BLOQ.OKBLOQ'));
            // actualizar página
            this.employeeId = 0;
            this.buildCalendar();
            this.refreshCalendar.emit();
          } else {
            this.notification.setWarning(this.translate.instant('BLOQ.ERRBLOQ'));
            // this._observatoryService.setData('loader', false);
          }
        })
      );
    }
  }

  notAllowSelect(): boolean {
    const lastDayMonthBloq = new Date(this.dateInitBloq.year, this.dateInitBloq.month, 0);
    // si el último dia bloqueado es igual al  penúltimo dia del mes, y
    // el día seleccionado fromDate es igual al último dia del mes
    if (this.dateInitBloq.day === lastDayMonthBloq.getDate() - 1) {
      if (this.fromDate.day === lastDayMonthBloq.getDate()) {
        return true;
      } else {
        this.notification.setWarning(this.translate.instant('BLOQ.PRIMERAFECHAERROR'));
        return false;
      }
      // si el ultimo dia bloqeuado es el mismo que el último dia de mes que tiene los bloqueos
    } else if (this.dateInitBloq.day === lastDayMonthBloq.getDate()) {
      if (this.fromDate.day === 1 &&
        (this.dateInitBloq.month + 1 === this.fromDate.month || this.dateInitBloq.month === 12 && this.fromDate.month === 1)) {
        return true;
      } else {
        this.notification.setWarning(this.translate.instant('BLOQ.PRIMERAFECHAERROR'));
        return false;
      }
    } else if (this.dateInitBloq.day + 1 === this.fromDate.day) {
      return true;
    } else {
      this.notification.setWarning(this.translate.instant('BLOQ.PRIMERAFECHAERROR'));
      return false;
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.sendFromDate.emit(this.fromDate);
    this.sendToDate.emit(this.toDate);
  }

  resetFocusAndSelection() {
    this.fromDate = undefined;
    this.toDate = undefined;
    if (this.datepicker) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      this.navigateToDate({ year, month });
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  isToday = (date: NgbDate) => {
    return date.day === this.today.getDate() &&
      date.month === this.today.getMonth() + 1 &&
      date.year === this.today.getFullYear();
  }


  isExternal(date: NgbDate): boolean {
    if (this.markDisable) {
      const list = this.listBlockExternal;
      // tslint:disable-next-line:forin
      for (const i in list) {
        const anio = Number(list[i].date.substring(0, 4));
        const mes = Number(list[i].date.substring(4, 6));
        const dia = Number(list[i].date.substring(6, 8));
        const dayToBlock: NgbDate = new NgbDate(anio, mes, dia);
        if (date.day === dayToBlock.day && date.month === dayToBlock.month && date.year === dayToBlock.year) {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  isEmploye(date: NgbDate): boolean {
    if (this.markDisable) {
      const list = this.listBlockEmploye;
      // tslint:disable-next-line:forin
      for (const i in list) {
        const anio = Number(list[i].date.substring(0, 4));
        const mes = Number(list[i].date.substring(4, 6));
        const dia = Number(list[i].date.substring(6, 8));
        const dayToBlock: NgbDate = new NgbDate(anio, mes, dia);
        if (date.day === dayToBlock.day && date.month === dayToBlock.month && date.year === dayToBlock.year) {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  takeEmployee(data) {
    if (data.Id === '') {
      this.employeeId = null;
      data.Id = null;
      this.buildCalendar();
    } else {
      this.employeeId = data.Id;
      this.buildCalendar(this.employeeId);
    }
  }

  existMarkDisable(): boolean {
    return this.markDisable !== undefined && this.markDisable === true;
  }

  existDateInitBloq(): boolean {
    return this.dateInitBloq !== undefined;
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

  navigateToDate(data: { year: number, month: number }) {
    this.datepicker.navigateTo({year: data.year, month: data.month});
  }
}
